import { render, staticRenderFns } from "./ReviewCard.vue?vue&type=template&id=5aa7ff2d&scoped=true"
import script from "./ReviewCard.vue?vue&type=script&lang=js"
export * from "./ReviewCard.vue?vue&type=script&lang=js"
import style0 from "./ReviewCard.vue?vue&type=style&index=0&id=5aa7ff2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa7ff2d",
  null
  
)

export default component.exports